import { render } from "./SmartFilterDataTag.vue?vue&type=template&id=fdf5f4b0"
import script from "./SmartFilterDataTag.vue?vue&type=script&lang=js"
export * from "./SmartFilterDataTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__